<main>
    <div class="profil_left">
        <app-menus></app-menus>
    </div>
    <div class="profil_right">
        <h2>Profil</h2>
        <div class="profil_photo_ctn">
            <img *ngIf="imgGot == true" (click)="manageDropDown()" class="profil_avatar" src="{{userProfileImg | async}}" alt="avatar">
            <img *ngIf="imgGot == false" (click)="manageDropDown()" src="../../../assets/icons/default_avatar.svg" class="profil_avatar">
            <button (click)="changerPhoto()">Changer la photo</button>
            <input (change)="confirmedChange()" type="file" accept="image/*" name="avatar_upload" id="file">
        </div>
        <div class="profil_infos">
            <h3><b>Informations personnelles</b></h3>
            <hr>
            <div class="profil_noms">
                <label for="prenom">
                    <p>Prénom</p>
                    <input type="text" name="prenom" [value]="userFirstname">
                </label>
                <label for="nom">
                    <p>Nom</p>
                    <input type="text" name="nom" [value]="userLastName">
                </label>
            </div>
            <label for="courriel">
                <p>Courriel</p>
                <input type="email" name="couriel" [value]="userEmail" disabled>
            </label>
            <label for="ecole">
                <p>École</p>
                <input type="text" name="école" [value]="userEcoleName">
            </label>
            <h3><b>Informations sur ma classe</b></h3>
            <hr>
            <app-classes></app-classes>
        </div>
        <button *ngIf="userType == 'enseignant'" (click)="manageClasseModal()">Créer une classe</button>
        <button *ngIf="userType == 'participant' && isUserClassesEmpty == true" (click)="manageClasseModal()">Rejoindre une classe</button>
        <div *ngIf="userType == 'participant'" class="classes_modal">
            <span (click)="manageClasseModal()" class="material-icons">close</span>                
            <h3>Rejoindre une classe</h3>
            <label for="cdc">Code de Classe (cdc)</label>
            <input name="cdc" [(ngModel)]="classCode">
            <button  (click)="joinClasse()">Rejoindre</button>
        </div>
        <div *ngIf="userType == 'enseignant'" class="classes_modal" style="display: none;">
            <span (click)="manageClasseModal()" class="material-icons">close</span>
            <h3>Ajouter une classe</h3>
            <label for="">Nom de la classe</label>
            <input [(ngModel)]="className">
            <mat-form-field appearance="fill">
                <mat-label>Niveau de classe</mat-label>
                <mat-select [(ngModel)]="classLevel" multiple>
                    <mat-option value="Maternelle">Maternelle</mat-option>
                    <mat-option value="1">1</mat-option>
                    <mat-option value="2">2</mat-option>
                    <mat-option value="3">3</mat-option>
                    <mat-option value="4">4</mat-option>
                    <mat-option value="5">5</mat-option>
                    <mat-option value="6">6</mat-option>
                    <mat-option value="7">7</mat-option>
                    <mat-option value="8">8</mat-option>
                    <mat-option value="9">9</mat-option>
                    <mat-option value="10">10</mat-option>
                    <mat-option value="11">11</mat-option>
                    <mat-option value="12">12</mat-option>
                </mat-select>
            </mat-form-field>
            <button (click)="addClasse()">Ajouter</button>
        </div>
    </div>
</main>